import CONFIG from 'Config/settings';
import { t } from 'Utils/localization/i18next';

const getValidationField = label => {
  const translatedLabel = t(label);

  return CONFIG.FEATURE?.VALIDATION?.KEEP_PLACEHOLDER_CAPITALIZATION
    ? translatedLabel
    : translatedLabel.toLocaleLowerCase();
};

const validationMessage = (validatorName, label, message, args = {}) => {
  if (message) {
    return [
      t(message, {
        field: getValidationField(label),
        ...args
      })
    ];
  }

  if (label) {
    return [
      t(`forms.validation.${validatorName}`, {
        field: getValidationField(label),
        ...args
      })
    ];
  }

  return [t('forms.validation.invalidGeneral')];
};

export default validationMessage;
